@if (isStartedSearch()) {
	<tui-loader
		[overlay]="true"
		[showLoader]="isLoadingAssets()"
	>
		<div class="search-assets-table">
			@if (isLoadingAssets()) {
				<div class="no-items">
					<span class="no-items-title">{{ 'searchAssets.searching' | translate }}</span>
				</div>
			} @else {
				@for (asset of searchAssetsResponse()?.assets; let index = $index; track asset.id) {
					@let value = searchValue();
					@if (value) {
						<div
							class="asset"
							[style.--row-delay]="index * 50 + 'ms'"
							(click)="selectAsset(asset)"
						>
							<div class="asset-left">
								<div class="asset-left-title">
									<span
										class="symbol"
										[tuiHighlight]="value"
										tuiHighlightColor="var(--brand-300)"
										>{{ asset.symbol }}</span
									>
									<tui-badge
										size="s"
										appearance="neutral"
										>{{ asset.exchange }}</tui-badge
									>
								</div>
								@if (asset.name) {
									<span
										[tuiHighlight]="value"
										tuiHighlightColor="var(--brand-300)"
										class="asset-left-description"
									>
										{{ asset.name }}
									</span>
								}
							</div>
							<div>
								@if (watchList()) {
									@let hasAssetInWatchList = checkHasAssetInWatchList(asset);
									<span class="star-icon">
										<tui-loader
											[showLoader]="symbolsLoading().includes(asset.symbol)"
											[overlay]="true"
											size="m"
										>
											<tui-icon
												[icon]="hasAssetInWatchList ? '@tui.star-filled' : '@tui.star'"
												class="icon"
												[class.active]="hasAssetInWatchList"
												(click.stop)="
													hasAssetInWatchList
														? deleteAssetFromWatchList(asset)
														: addAssetToWatchList(asset)
												"
											/>
										</tui-loader>
									</span>
								}
							</div>
						</div>
					}
				} @empty {
					<div class="no-items">
						<span class="no-items-title">{{ 'searchAssets.tickersNotFound' | translate }}</span>
					</div>
				}
			}
		</div>
	</tui-loader>
}
